/* eslint-disable max-lines */
/* eslint-disable max-len */
import { MarketInfo, ResourceStrings } from "@gamedev-web/gamedev-sdk-core";

export const getResourceStringsAsync = async (marketInfo: MarketInfo): Promise<ResourceStrings> => {
  let strings: ResourceStrings;
  try {
    strings = (
      await import(
        /* webpackChunkName: "[request]" */ `./strings/strings.${marketInfo.localeWithScript}.resjson`
      )
    ).default;
  } catch (e) {
    try {
      strings = (
        await import(
          /* webpackChunkName: "[request]" */ `./strings/strings.${marketInfo.language}.resjson`
        )
      ).default;
    } catch (innerException) {
      strings = (
        await import(/* webpackChunkName: "onboarding.resjson" */ "./strings/strings.resjson")
      ).default as ResourceStrings;
    }
  }

  return strings;
};
